import { QUERY_CACHE_ENS_TIME, chains } from "@sablier/v2-constants";
import { useEnsAddress as useWagmiEnsAddress } from "wagmi";

type Props = NonNullable<Parameters<typeof useWagmiEnsAddress>[0]>;

export default function useResolvedAddress({
  cacheTime = QUERY_CACHE_ENS_TIME,
  chainId = chains.mainnet.chainId,
  enabled,
  name,
  staleTime,
  suspense,
  ...props
}: Props) {
  return useWagmiEnsAddress({
    ...props,
    cacheTime,
    chainId,
    enabled: !!enabled && chainId === chains.mainnet.chainId,
    name,
    staleTime,
    suspense,
  });
}
